<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title"  i18n="parameters-user|@@user">Utilisateur</span>
    </div>
  </div>
    <div class="row">
      <div class="col-12 report-form">
        <span class="column-title" i18n="parameters-user|@@profile">Profil</span>
        <div class="container">
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt"  i18n="parameters-user|@@lastName">Nom : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Nom" [(ngModel)]="lastName" (change)="sendData()">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt"  i18n="parameters-user|@@firstName">Prénom : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Prénom" [(ngModel)]="firstName" (change)="sendData()">
            </div>
          </div>
        </div>
      </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/element/parameters-user/parameters-user.component.html